export const DEVICE_META = {
    ios: { iconClass: 'fa-brands fa-apple', label: 'iOS' },
    android: { iconClass: 'fa-brands fa-android', label: 'Android' },
    pc: { iconClass: 'fa-brands fa-windows', label: 'PC' },
    mac: { iconClass: 'fa-solid fa-desktop', label: 'Mac' },
};
/** Render order for device chips/icons across every surface. */
export const DEVICE_ORDER = ['ios', 'android', 'pc', 'mac'];
export const LANGUAGE_LABELS = {
    english: 'English',
    spanish: 'Spanish',
};
export function sortedDevices(devices) {
    return DEVICE_ORDER.filter((d) => devices.includes(d));
}
//# sourceMappingURL=tester-meta.js.map